// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__mANWW","icon":"styles_icon__AeQ3+"};